var MediaType;
(function (MediaType) {
    MediaType["MEDIA_AUDIO"] = "media::audio";
    MediaType["MEDIA_IMAGE"] = "media::image";
    MediaType["MEDIA_VIDEO"] = "media::video";
})(MediaType || (MediaType = {}));
export {};
